import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Empty, List, Row, Select } from 'antd';
import { updateTrainerInfo } from '../../../services/trainerServices';
import {
  editFormStaticPropsData,
  errorStatus,
  idleStatus,
  loadingStatus,
  socialMediaOptions,
  staticData,
  successStatus,
} from './constants';
import SocialEdit from './components/SocialEdit';
import SocialMediaCard from './components/SocialMediaCard';
import DeleteSocialMedia from './components/DeleteSocialMedia/DeleteSocialMedia';

const { Option } = Select;

const SocialMediaContainer = ({ trainer, updateTrainerLocalData }) => {
  const initialValues = {
    link: '',
    type: '',
  };

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [status, setStatus] = useState(idleStatus);
  const [isSocialModalOpen, setIsSocialModalOpen] = useState(false);
  const [socialMediaToDelete, setSocialMediaToDelete] = useState(null);

  const toggleSocialEdit = () => {
    setIsSocialModalOpen((prev) => !prev);
  };

  const handleTrainerInfoUpdate = (id, data) => {
    setStatus(loadingStatus);
    return updateTrainerInfo(id, data)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus(successStatus);
      })
      .catch((err) => {
        alert(err);
        setStatus(errorStatus);
      });
  };

  const onDelete = async () => {
    const socialMedia = trainer.socialMedia.filter(
      (item) => item.type !== socialMediaToDelete
    );

    const trainerData = { ...trainer, socialMedia };

    await handleTrainerInfoUpdate(trainer.trainerId, trainerData).then(() => {
      if (status.type === successStatus.type) setSocialMediaToDelete(null);
    });
  };

  const onUpdate = (index) => async (values) => {
    const socialMedia = trainer.socialMedia;
    socialMedia[index] = values;
    const trainerData = {
      ...trainer,
      socialMedia,
    };

    await handleTrainerInfoUpdate(trainer.trainerId, trainerData);
  };

  const toggleAdd = () => {
    setIsAddOpen((prev) => !prev);
  };

  const onSubmit = async (values) => {
    const socialMedia = [...trainer.socialMedia];
    socialMedia.push(values);
    const trainerData = {
      ...trainer,
      socialMedia,
    };

    await handleTrainerInfoUpdate(trainer.trainerId, trainerData);
  };

  const currentSocialMediaTypes =
    trainer.socialMedia?.length > 0
      ? trainer.socialMedia?.map((media) => media.type)
      : [];

  // Filter out existing social media types
  const linkTypeMenu = socialMediaOptions
    .filter((link) => !currentSocialMediaTypes.includes(link.value))
    .map((link) => (
      <Option key={link.name} value={link.value}>
        {link.name}
      </Option>
    ));

  return (
    <div>
      <Row justify="space-between">
        <h2>{staticData.title}</h2>
        <Button onClick={toggleAdd} type="primary">
          {staticData.buttonLabel}
        </Button>
      </Row>
      {trainer.socialMedia?.length ? (
        <List
          itemLayout="vertical"
          size="large"
          dataSource={trainer.socialMedia}
          renderItem={(item, index) => (
            <SocialMediaCard
              key={index}
              item={item}
              toggleSocialEdit={toggleSocialEdit}
              onSubmit={onUpdate(index)}
              isModalOpened={isSocialModalOpen}
              typeInputProps={editFormStaticPropsData.typeInput}
              linkInputProps={editFormStaticPropsData.linkInput}
              modalTitle={editFormStaticPropsData.modal.addTitle}
              isLoading={status.type === 'LOADING'}
              isError={status.type === 'ERROR'}
              errorMsg={errorStatus.message}
              isSuccess={status.type === 'SUCCESS'}
              successMsg="Successfully Updated!"
              handleDelete={setSocialMediaToDelete}
            />
          )}
        />
      ) : (
        <Empty />
      )}
      {trainer ? (
        <SocialEdit
          initialValues={initialValues}
          isOpen={isAddOpen}
          toggle={toggleAdd}
          onSubmit={onSubmit}
          linkTypeMenu={linkTypeMenu}
          typeInputProps={editFormStaticPropsData.typeInput}
          linkInputProps={editFormStaticPropsData.linkInput}
          modalTitle={editFormStaticPropsData.modal.editTitle}
          isLoading={status.type === 'LOADING'}
          isError={status.type === 'ERROR'}
          errorMsg={errorStatus.message}
          isSuccess={status.type === 'SUCCESS'}
          successMsg="Successfully Added!"
        />
      ) : null}
      {socialMediaToDelete !== null && (
        <DeleteSocialMedia
          onSubmit={onDelete}
          onClose={() => setSocialMediaToDelete(null)}
          title={`Are you sure you want to delete ${socialMediaToDelete} link?`}
          isLoading={status.type === 'LOADING'}
          isError={status.type === 'ERROR'}
          errorMsg={errorStatus.message}
        />
      )}
    </div>
  );
};

SocialMediaContainer.propTypes = {
  trainer: PropTypes.object,
  updateTrainerLocalData: PropTypes.func.isRequired,
};

export default SocialMediaContainer;
